import { FavoriteEntryType, ProcedureCategory } from "ts-types/api.enums";
import { EntryFavoriteDto } from "ts-types/api.types";

/** Favorite state of entries, keyed by {@link favoriteKey}. */
export type FavoritesMap = { [key: string]: boolean };

export const favoriteKey = (entryType: FavoriteEntryType | string, entryId: number): string => {
  return `${entryType}:${entryId}`;
};

export const toFavoritesMap = (favorites: Array<EntryFavoriteDto>): FavoritesMap => {

  const favoritesMap: FavoritesMap = {};

  favorites.forEach(favorite => {
    favoritesMap[favoriteKey(favorite.entryType, favorite.entryId)] = favorite.favorite;
  });

  return favoritesMap;
};

/**
 * The favorite entry type of the search results of a procedure category, or undefined
 * when the results of the category cannot be marked as favorites (e.g. cost estimation entries).
 */
export const getFavoriteEntryType = (procedureCategory?: ProcedureCategory): FavoriteEntryType | undefined => {

  switch (procedureCategory) {
    case ProcedureCategory.PROCEDURE:
    case ProcedureCategory.PROCEDURE_GROUP:
      return FavoriteEntryType.PROCEDURE;
    case ProcedureCategory.BLOCK_PROCEDURE:
      return FavoriteEntryType.BLOCK_PROCEDURE;
    case ProcedureCategory.MEDICAMENT:
    case ProcedureCategory.MATERIAL:
      return FavoriteEntryType.MEDICAMENT;
    default:
      return undefined;
  }
};
